exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".inputW_708f858{width:230px!important}.enabled_e2f0214{background-color:#1890ff}.disabled_319eb7c,.enabled_e2f0214{display:inline-block;width:5px;height:5px;border-radius:50%;vertical-align:middle;margin-right:5px}.disabled_319eb7c{background-color:#f5222d}.deleted_f491653{background-color:#52c41a}.deleted_f491653,.doing_f623675{display:inline-block;width:5px;height:5px;border-radius:50%;vertical-align:middle;margin-right:5px}.doing_f623675{background-color:#ffba18}", ""]);

// exports
exports.locals = {
	"inputW": "inputW_708f858",
	"enabled": "enabled_e2f0214",
	"disabled": "disabled_319eb7c",
	"deleted": "deleted_f491653",
	"doing": "doing_f623675"
};